import practiceInstruction from '../sounds/spelling_practice_instruction.mp3';
import practiceInstructionStart from '../sounds/spelling_practice_instruction_start.mp3';
import clickOKInstruction from '../sounds/spelling_click_ok_practice_instruction.mp3';
import practiceInstructionReady from '../sounds/spelling_practice_instruction_ready.mp3';
import practiceInstructionActive from '../sounds/spelling_practice_instruction_active.mp3';
import clickOk from '../sounds/click_ok.mp3';
import replayInstruction from '../sounds/spelling_replay_instruction.mp3';
import practiceInstructionClearButton from '../sounds/spelling_practice_instruction_clear_button.mp3';

import practiceInstructionSpanish from '../sounds/spanish/spelling_practice_instruction_spa.mp3';
import practiceInstructionStartSpanish from '../sounds/spanish/spelling_practice_instruction_start_spa.mp3';
import clickOKInstructionSpanish from '../sounds/spanish/spelling_click_ok_practice_instruction_spa.mp3';
import practiceInstructionReadySpanish from '../sounds/spanish/spelling_practice_instruction_ready_spa.mp3';
import practiceInstructionActiveSpanish from '../sounds/spanish/spelling_practice_instruction_active_spa.mp3';
import clickOkSpanish from '../sounds/spanish/clic_continuare_2021.mp3';
import replayInstructionSpanish from '../sounds/spanish/spelling_replay_instruction_spa.mp3';
import practiceInstructionClearButtonSpanish from '../sounds/spanish/spelling_practice_instruction_clear_button_spa.mp3';

// Alyx English Audios
import practiceInstructionAlyx from '../sounds/alyx/english/spelling_practice_instruction_alyx.mp3';
import practiceInstructionStartAlyx from '../sounds/alyx/english/spelling_practice_instruction_start_alyx.mp3';
import clickOKInstructionAlyx from '../sounds/alyx/english/spelling_click_ok_practice_instruction_alyx.mp3';
import practiceInstructionReadyAlyx from '../sounds/alyx/english/spelling_practice_instruction_ready_alyx.mp3';
import practiceInstructionActiveAlyx from '../sounds/alyx/english/spelling_practice_instruction_active_alyx.mp3';
import clickOkAlyx from '../sounds/alyx/english/click_ok_alyx.mp3';
import replayInstructionAlyx from '../sounds/alyx/english/spelling_replay_instruction_alyx.mp3';
import practiceInstructionClearButtonAlyx from '../sounds/alyx/english/spelling_practice_instruction_clear_button_alyx.mp3';

// Alyx Spanish Audios
import practiceInstructionSpanishAlyx from '../sounds/alyx/spanish/spelling_practice_instruction_spa_Alyx.mp3';
import practiceInstructionStartSpanishAlyx from '../sounds/alyx/spanish/spelling_practice_instruction_start_spa_Alyx.mp3';
import clickOKInstructionSpanishAlyx from '../sounds/alyx/spanish/spelling_click_ok_practice_instruction_spa_Alyx.mp3';
import practiceInstructionReadySpanishAlyx from '../sounds/alyx/spanish/spelling_practice_instruction_ready_spa_Alyx.mp3';
import practiceInstructionActiveSpanishAlyx from '../sounds/alyx/spanish/spelling_practice_instruction_active_spa_Alyx.mp3';
import clickOkSpanishAlyx from '../sounds/alyx/spanish/clic_continuare_2021_Alyx.mp3';
import replayInstructionSpanishAlyx from '../sounds/alyx/spanish/spelling_replay_instruction_spa_Alyx.mp3';
import practiceInstructionClearButtonSpanishAlyx from '../sounds/alyx/spanish/spelling_practice_instruction_clear_button_spa_Alyx.mp3';
import { selectAvatarAudio } from '../common/alex/AlexUtils';
import { LANGUAGES } from '../common/localization';

export const SPELLING_AUDIO_INSTRUCTIONS = {
    [LANGUAGES.ENGLISH]: {
        practiceInstruction: selectAvatarAudio(practiceInstruction, practiceInstructionAlyx),
        practiceInstructionStart: selectAvatarAudio(
            practiceInstructionStart,
            practiceInstructionStartAlyx,
        ),
        clickOKInstruction: selectAvatarAudio(clickOKInstruction, clickOKInstructionAlyx),
        practiceInstructionReady: selectAvatarAudio(
            practiceInstructionReady,
            practiceInstructionReadyAlyx,
        ),
        practiceInstructionActive: selectAvatarAudio(
            practiceInstructionActive,
            practiceInstructionActiveAlyx,
        ),
        clickOk: selectAvatarAudio(clickOk, clickOkAlyx),
        practiceInstructionClearButton: selectAvatarAudio(
            practiceInstructionClearButton,
            practiceInstructionClearButtonAlyx,
        ),
        replayInstruction: selectAvatarAudio(replayInstruction, replayInstructionAlyx),
    },
    [LANGUAGES.SPANISH]: {
        practiceInstruction: selectAvatarAudio(
            practiceInstructionSpanish,
            practiceInstructionSpanishAlyx,
        ),
        practiceInstructionStart: selectAvatarAudio(
            practiceInstructionStartSpanish,
            practiceInstructionStartSpanishAlyx,
        ),
        clickOKInstruction: selectAvatarAudio(
            clickOKInstructionSpanish,
            clickOKInstructionSpanishAlyx,
        ),
        practiceInstructionReady: selectAvatarAudio(
            practiceInstructionReadySpanish,
            practiceInstructionReadySpanishAlyx,
        ),
        practiceInstructionActive: selectAvatarAudio(
            practiceInstructionActiveSpanish,
            practiceInstructionActiveSpanishAlyx,
        ),
        clickOk: selectAvatarAudio(clickOkSpanish, clickOkSpanishAlyx),
        practiceInstructionClearButton: selectAvatarAudio(
            practiceInstructionClearButtonSpanish,
            practiceInstructionClearButtonSpanishAlyx,
        ),
        replayInstruction: selectAvatarAudio(
            replayInstructionSpanish,
            replayInstructionSpanishAlyx,
        ),
    },
};

export const PRACTICE_LETTERS = ['d', 'o', 'g'];

export const PRACTICE_LETTERS_SPANISH = ['r', 'o', 'p', 'a'];

export const CLEAR_BUTTON_INSTRUCTION_RESPONSE = ['dot'];
export const CLEAR_BUTTON_INSTRUCTION_RESPONSE_SPANISH = ['ropi'];
